import { captureException } from '@sentry/vue';

import { log } from '@libs/utils';

import { getErrorMessage } from './errorMessage';

export function logException(
  error: unknown,
  value?: Record<string, unknown>
): void;
export function logException(
  message: string,
  value?: Record<string, unknown>
): void;
export function logException(
  errorOrMessage: unknown,
  value?: Record<string, unknown>
): void {
  if (import.meta.env.MODE === 'development') {
    console.error(errorOrMessage, value);
  } else {
    const errorMsg = getErrorMessage(errorOrMessage);
    log('Sentry', errorMsg);

    captureException(new Error(errorMsg), {
      extra: {
        value,
      },
    });
  }
}
